import React from 'react';
import { Box } from '@mui/material';
import GrowSetupConfiguration from '../../components/GrowSetupConfiguration';

export default function SettingsPage() {
  return (
    <Box
      sx={{
        animation: 'fadeSlideUpCard 0.5s cubic-bezier(0.22,1,0.36,1) both',
        '& .MuiCard-root, & .MuiPaper-root': {
          background: 'rgba(15,28,15,0.75) !important',
          border: '1px solid rgba(118,196,66,0.12) !important',
          backdropFilter: 'blur(16px)',
          borderRadius: '14px !important',
        },
        '& .MuiButton-containedPrimary': {
          background: 'linear-gradient(135deg,#76c442 0%,#559e2e 100%) !important',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#76c442 !important',
        },
      }}
    >
      <GrowSetupConfiguration />
      <style>{`
        @keyframes fadeSlideUpCard {
          from { opacity:0; transform:translateY(20px); }
          to   { opacity:1; transform:translateY(0);    }
        }
      `}</style>
    </Box>
  );
}
